var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.classStyle},_vm.$listeners),[(_vm.loading)?[_vm._v(" "+_vm._s(_vm.loadingText)+" "),_c('spinner')]:[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }